import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Button } from '@/components/ui/Button/Button';
import { ModalFooterAction } from '@/components/ui/Modal/Modal';
import { ModalWithTitle } from '@/components/ui/Modal/ModalWithTitle';
export const ConfirmModal = (props) => {
    const { children, className = '', headText, hideModal, isShow } = props;
    return (_jsxs(ModalWithTitle, Object.assign({ className: className, headText: headText, hideModal: hideModal, isShow: isShow }, { children: [children, _jsx(ModalFooterAction, { children: _jsx(Button, Object.assign({ color: 'gray', onClick: hideModal, size: 'md' }, { children: "\u9589\u3058\u308B" })) })] })));
};
